import styled from 'styled-components'
import Image from 'next/legacy/image'
import { useLearningPlan } from 'querys/course'
import LearningPlanCourseItem from './learning-plan-course-item'
import LearningPlanProjectItem from './learning-plan-project-item'

const LearningPlanStyled = styled.div`
  display: block;
  .learning-plan-container {
    position: relative;
    inline-size: fit-content;
  }
  .two-light {
    display: none;
  }
  .one-light {
    display: none;
  }
  .learning-plan {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  .learning-plan-step {
    &:nth-of-type(even) {
      margin-inline-start: 56px;
    }
  }
  @media(min-width: 1024px) {
    display: block;
    padding-block-end: 6rem;
    .two-light {
      display: block;
      position: absolute;
      transform: translateY(300%) translateX(-180px);
    }
    .one-light {
      display: block;
      position: absolute;
      right: 0;
      transform: translateY(700%) translateX(100px);
      /* top: 325px; */
    }
    .learning-plan {
      /* margin-left: 120px; */
      inline-size: fit-content;
    }
    .learning-plan-step {
      max-inline-size: 500px;
      &:nth-of-type(even) {
        margin-inline-start: 56px;
      }
      &:nth-of-type(4n + 3) {
        margin-inline-start: 112px;
      }
    }
  }
`

function LearningPlan({
  setCourse, itemActive, setItemActive,
}) {
  const { data } = useLearningPlan()

  return (
    <LearningPlanStyled id="learning-plan">
      <div className="learning-plan-container">
        <div className="two-light">
          <Image src="/images/errors/500_ilustration.png" width={188} height={160} />
        </div>
        <div className="one-light">
          <Image src="/images/errors/200_ilustration.png" width={135} height={135} />
        </div>
        <div className="learning-plan">
          {data?.map((item, idx) => (
            'course_progress' in item ? (
              <LearningPlanCourseItem key={item.uuid} {...item} setCourse={setCourse} idx={idx} itemActive={itemActive} setItemActive={setItemActive} />
            ) : (
              <LearningPlanProjectItem key={item.slug} {...item} itemActive={itemActive} setItemActive={setItemActive} />
            )
          ))}
        </div>
      </div>
    </LearningPlanStyled>
  )
}

export default LearningPlan
